module.exports = __webpack_public_path__ + "img/10d.a43e74e2.png";